class Setting {
  env: string;
  vicWebUrl: string;
  apiServerUrl: string;
  chatServerUrl: string;
  socketServerUrl: string;
  cdnPrefix: string;

  constructor() {
    this.env = process.env.REACT_APP_ENV || EMPTY;
    this.vicWebUrl = process.env.REACT_APP_VIC_WEB_URL || EMPTY;
    this.apiServerUrl = process.env.REACT_APP_API_URL || EMPTY;
    this.chatServerUrl = process.env.REACT_APP_CHAT_URL || EMPTY;
    this.socketServerUrl = process.env.REACT_APP_SOCKET_URL || EMPTY;
    this.cdnPrefix = process.env.REACT_APP_CDN_PREFIX || EMPTY;
  }
}

const EMPTY: string = '';

const config: Setting = new Setting();

export { Setting, config };
